export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8218.9ece6383.jpg";